/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Granim from 'granim';
import s from './Footer.css';
import Link from '../../../components/Link';
import appStoreDownload from './app-store-download.png';
import appStoreDownload2x from './app-store-download@2x.png';
import googlePlayDownload from './google-play-download.png';
import googlePlayDownload2x from './google-play-download@2x.png';
import { isIOS, isAndroid, isBrowser } from 'react-device-detect';

const APP_STORE_URL = 'https://itunes.apple.com/app/id1471098086';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.holgersindbaek.habitual';

class Footer extends React.Component {
  componentDidMount() {
    const granimInstance = new Granim({
      element: '#footer-granim-canvas',
      name: 'granim',
      opacity: [1, 1],
      direction: 'diagonal',
      isPausedWhenNotInView: false,
      stateTransitionSpeed: 160,
      states: {
        'default-state': {
          gradients: [['#E7F5FF', '#A5D8FF'], ['#A5D8FF', '#E7F5FF']],
        },
      },
      onStart: () => {
        setTimeout(() => {
          document.querySelector('#footer-granim-canvas').style.opacity = 1;
        }, 320);
      },
    });
  }

  render() {
    const showIOSDownloadLink = isIOS || isBrowser;
    const showAndroidDownloadLink = isAndroid || isBrowser;

    return (
      <div className={s.root}>
        <canvas id="footer-granim-canvas" className={s.granim} />
        <div className={s.container}>
          <div className={s.banner}>
            <h1 className={s.bannerTitle}>
              Track habits, build <br className={s.desktop} />routines & accomplish goals.
            </h1>
            <p className={s.bannerBody}>
              Habitual is a habit tracker that helps you <br className={s.desktop} />form great habits, reach your goals and <br className={s.desktop} />get your life in balance.
            </p>
            <div className={s.appStoreContainer}>
              {showIOSDownloadLink &&
                <a
                  target="_blank"
                  className={s.appStoreLink}
                  href={APP_STORE_URL}
                >
                  <img
                    src={appStoreDownload}
                    srcSet={`${appStoreDownload2x} 2x`}
                    width="212"
                    height="72"
                    alt="App store link"
                  />
                </a>
              }
              <span></span>
              {showAndroidDownloadLink &&
                <a
                  target="_blank"
                  className={s.googlePlayLink}
                  href={GOOGLE_PLAY_URL}
                >
                  <img
                    src={googlePlayDownload}
                    srcSet={`${googlePlayDownload2x} 2x`}
                    width="212"
                    height="72"
                    alt="Google play link"
                  />
                </a>
              }
            </div>
          </div>
          <div className={s.navigation}>
            <p className={s.copyright}>
              © 2026 Holger Sindbaek. All rights reserved.
            </p>
            <Link className={s.link} to="/contact">
              Contact
            </Link>
            <Link className={s.link} to="/privacy-policy">
              Privacy policy
            </Link>
            <Link className={s.link} to="/terms-of-use">
              Terms of use
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Footer);
